"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentGroupItem = exports.SegmentGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var create_rocket_1 = require("../_util/create-rocket");
var config_context_1 = require("../_util/config-context");
exports.SegmentGroup = create_rocket_1.createRocket("Group", "div.@{prefix}-region-pave");
function SegmentGroupItem(_a) {
    var name = _a.name, children = _a.children;
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", { className: classPrefix + "-region-pave__item" },
        react_1.default.createElement("span", { className: classPrefix + "-region-pave__area-name" },
            react_1.default.createElement("i", null, name)),
        children));
}
exports.SegmentGroupItem = SegmentGroupItem;
SegmentGroupItem.displayName = "SegmentGroupItem";
//# sourceMappingURL=SegmentGroup.js.map